import "./style.css";
export default function CircularPercent({ percent }) {
   
    return (
        <div className="avatar-round-add">
            <svg viewBox="0 0 36 36" className="circular-chart-add purple">
                <path
                    className="circle-bg-add"
                    d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
                />
                <path
                    className="circle"
                    strokeDasharray={`${percent}, 100`}
                    d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
                />
                <text x="18" y="20.35" className="percentage-add">{percent}%</text>
            </svg>
        </div>
    );
}
